import { useState, useEffect } from 'react';
import { en } from '../i18n/translations/en';
import { zh } from '../i18n/translations/zh';

const translations = { en, zh };

const getByPath = (obj, path) => {
  if (!obj || !path) return undefined;
  return path.split('.').reduce((acc, key) => (acc ? acc[key] : undefined), obj);
};

export const useTranslation = () => {
  const [language, setLanguage] = useState(() => {
    const storedLang = localStorage.getItem('language');
    return storedLang || 'en';
  });

  useEffect(() => {
    localStorage.setItem('language', language);
    document.documentElement.setAttribute('lang', language);
  }, [language]);

  const switchLanguage = (lang) => {
    setLanguage(lang);
  };

  const strings = translations[language] || translations.en;
  const t = (key) => getByPath(strings, key) ?? key;
  Object.assign(t, strings);

  return {
    t,
    currentLanguage: language,
    switchLanguage
  };
};
